// extracted by mini-css-extract-plugin
export var restart = "style-module--restart--FVrcm";
export var restart_image = "style-module--restart_image--almEI";
export var restart_title = "style-module--restart_title--qFB2+";
export var restart_description = "style-module--restart_description--ipVki";
export var restart_buttons = "style-module--restart_buttons--YMlPK";
export var buttons = "style-module--buttons--80JJ2";
export var buttons_item = "style-module--buttons_item--EZauX";